import React from 'react';
import { FormContainer } from '../../../form/FormContainer';
import FormItem from '../../../form/FormItem';
import ScheduleCalendarFormWidget from './ScheduleCalendarFormWidget';
import ScheduleLocationFormWidget from './ScheduleLocationFormWidget';
import ScheduleFormStandardDateOnlyWidget from './ScheduleFormStandardDateOnlyWidget';

export interface ScheduleFormStandardWidgetProps {
    name?: string;
    disabled?: boolean;
}

/**
 * Presentational component for standard vertical schedule form layout.
 *
 * Layout structure:
 * - Standard date-focused layout
 * - Location and calendar (side by side)
 */
export default function ScheduleFormStandardWidget({ name, disabled }: ScheduleFormStandardWidgetProps) {
    return (
        <>
            <ScheduleFormStandardDateOnlyWidget name={name} disabled={disabled} />
            <FormContainer>
                <FormItem half>
                    <ScheduleLocationFormWidget name={name} disabled={disabled} />
                </FormItem>
                <FormItem half>
                    <ScheduleCalendarFormWidget name={name} disabled={disabled} />
                </FormItem>
            </FormContainer>
        </>
    );
}
